<template>
<ItpUsercontrol
  :loading="loading"
  :reloading="reloading"
  :loaded="loaded"
  :error="error"
  @reload="evh_7315092382398562_reload($event, {})"
>
  <ItpFormGroup
    labelColsMd="3"
    contentColsMd="3"
    name="entry_date"
    :label="'Date'|pgettext('RegisterEntry')"
    :labelAlign="labelAlign"
    required
  >
    <ItpFormDatetime
      name="entry_date"
      v-model="item.entry_date"
      :readonly="item.isReadonly"
      required
    >
    </ItpFormDatetime>
  </ItpFormGroup>
  <ItpFormGroup
    labelColsMd="3"
    contentColsMd="9"
    name="document_type"
    :label="'Document type'|pgettext('RegisterEntry')"
    :labelAlign="labelAlign"
    contentClass="form-row"
    required
  >
    <div
      class="col-4"
    >
      <ItpFormSelect
        name="direction"
        v-model="item.direction"
        :options="directions"
        valueField="value"
        textField="text"
        :readonly="item.isReadonly"
      >
      </ItpFormSelect>
    </div>
    <div
      class="col-4"
    >
      <ItpFormSelect
        name="document_type"
        v-model="item.document_type"
        :options="documentTypes"
        valueField="value"
        textField="text"
        :disabled="item.isReadonly"
        @input="evh_1468474219929533_input($event, {})"
      >
      </ItpFormSelect>
    </div>
  </ItpFormGroup>
  <ItpFormGroup
    labelColsMd="3"
    contentColsMd="9"
    name="subject"
    :label="'Subject'|pgettext('RegisterEntry')"
    :labelAlign="labelAlign"
    required
  >
    <ItpFormInput
      name="subject"
      v-model="item.subject"
      required
      autofocus
      :disabled="item.isReadonly"
    >
    </ItpFormInput>
  </ItpFormGroup>
  <ItpFormGroup
    labelColsMd="3"
    contentColsMd="9"
    name="reference_number"
    :label="'Reference number'|pgettext('RegisterEntry')"
    :labelAlign="labelAlign"
    :helpTooltip="'The invoice number, contract number or other number identifying the registered document.'|pgettext('RegisterEntry|Help|Reference number')"
  >
    <ItpFormInput
      name="reference_number"
      v-model="item.reference_number"
      :readonly="item.isReadonly"
      @input="evh_6917646200545441_input($event, {})"
    >
    </ItpFormInput>
    <div
      class="alert alert-in-form alert-primary"
      v-if="invoiceCheckResult && invoiceCheckResult.register_entry == null"
    >
      <ItpIcon
        fa="info-circle"
        v-if="invoiceCheckResult.register_entry == null"
      >
      </ItpIcon>
      <span>
        {{ 'An invoice exists with the given number. Click to assign it to the current entry.'|pgettext('RegisterEntry') }}
      </span>
      <ItpLink
        :text="'Assign invoice'|pgettext('RegisterEntry')"
        class="d-inline-block"
        @click.prevent.stop="evh_6941071772471093_clickPreventStop($event, {})"
      >
      </ItpLink>
    </div>
    <div
      class="alert alert-in-form alert-warning"
      v-if="invoiceCheckResult && invoiceCheckResult.register_entry != null"
    >
      <ItpIcon
        fa="exclamation-circle"
      >
      </ItpIcon>
      <span>
        {{ 'An invoice exists with the given number but it\'s already registered.'|pgettext('RegisterEntry') }}
      </span>
      <UcRegisterEntryMiniCard
        :item="invoiceCheckResult.register_entry"
        no-icon
      >
      </UcRegisterEntryMiniCard>
    </div>
  </ItpFormGroup>
  <ItpFormGroup
    labelColsMd="3"
    contentColsMd="6"
    name="clerk"
    :label="'Clerk'|pgettext('RegisterEntry')"
    :labelAlign="labelAlign"
    :helpTooltip="'New values entered are memorized and saved to the database.'|pgettext('RegisterEntry|Help|Clerk')"
  >
    <ItpFormSelect2
      name="clerk"
      taggable
      :options="clerks"
      v-model="item.clerk"
      :readonly="item.isReadonly"
      valueField="name"
      textField="name"
    >
    </ItpFormSelect2>
  </ItpFormGroup>
  <ItpFormGroup
    labelColsMd="3"
    contentColsMd="9"
    name="client"
    :labelAlign="labelAlign"
    :label="'Partner'|pgettext('RegisterEntry')"
    :helpTooltip="'Search and select a company or enter it\'s name if the database does not contain its data. Type ENTER after typing in a new value.'|pgettext('RegisterEntry|Help|Partner')"
  >
    <UcRegisterEntryPartnerSelector
      :editor="item"
    >
    </UcRegisterEntryPartnerSelector>
  </ItpFormGroup>
  <hr>
  </hr>
  <ItpFormGroup
    labelColsMd="3"
    contentColsMd="9"
    name="invoice"
    :label="'Invoice'|pgettext('RegisterEntry')"
    :labelAlign="labelAlign"
    v-if="item.document_type == 'invoice'"
  >
    <UcRegisterEntryInvoiceSelector
      :editor="item"
    >
    </UcRegisterEntryInvoiceSelector>
    <ItpButton
      :text="'Create invoice...'|pgettext('RegisterEntry')"
      size="sm"
      variant="primary"
      :tooltip="'Create invoice with the given reference number.'|pgettext('RegisterEntry')"
      :icon="$config.addIcon"
      class="mt-2"
      v-if="item.id && (!item.invoice || !item.invoice.id) && item.reference_number"
      @click.prevent.stop="evh_7463771596263925_clickPreventStop($event, {})"
    >
    </ItpButton>
  </ItpFormGroup>
  <ItpFormGroup
    name="ref_entry"
    :label="'Reference entry'|pgettext('RegisterEntry')"
    :labelAlign="labelAlign"
    labelColsMd="3"
    contentColsMd="9"
    :helpTooltip="'Reference of an other entry in any version of the current register.'|pgettext('RegisterEntry|Help|Clerk')"
  >
    <ItpFormSelect2
      name="ref_entry"
      v-model="item.ref_entry"
      :dataSource="b_8680084583475136_dataSource"
      :initialOptions="item.ref_entry ? [item.ref_entry] : []"
      valueField="id"
      clearable
      bind-object
      optionTemplate="<UcSuggestRegisterEntryOption :option=option></UcSuggestRegisterEntryOption>"
      use-option-template-for-selected-option
      :readonly="item.isReadonly"
      @optionSelected="evh_8680084583475136_optionSelected($event, {})"
    >
    </ItpFormSelect2>
  </ItpFormGroup>
  <ItpFormGroup
    labelColsMd="3"
    contentColsMd="5"
    name="status"
    :label="'Status'|pgettext('RegisterEntry')"
    :labelAlign="labelAlign"
    :helpTooltip="'Type in arbitrary values to assign a status. The values are memorized. Press ENTER after typing in a new value.'|pgettext('RegisterEntry|Help|Status')"
  >
    <ItpFormSelect2
      name="status"
      taggable
      :options="statuses"
      v-model="item.status"
      :readonly="item.isReadonly"
      valueField="name"
      textField="name"
    >
    </ItpFormSelect2>
  </ItpFormGroup>
  <ItpFormGroup
    labelColsMd="3"
    contentColsMd="9"
    name="categories"
    :label="'Categories'|pgettext('RegisterEntry')"
    :labelAlign="labelAlign"
    :helpTooltip="'Assign multiple arbitrary values. The values are memorized. Press ENTER after typing in a new value.'|pgettext('RegisterEntry|Help|Categories')"
  >
    <ItpFormSelect2
      name="categories"
      multiple
      taggable
      :options="categories"
      v-model="item.categories"
      :readonly="item.isReadonly"
      valueField="name"
      textField="name"
    >
    </ItpFormSelect2>
  </ItpFormGroup>
  <ItpFormGroup
    labelColsMd="3"
    contentColsMd="9"
    name="project"
    :label="'Project'|pgettext('RegisterEntry')"
    :labelAlign="labelAlign"
  >
    <UcProjectSelector
      :item="item"
      name="project"
    >
    </UcProjectSelector>
  </ItpFormGroup>
  <ItpFormGroup
    labelColsMd="3"
    contentColsMd="3"
    name="delivery_date"
    :label="'Delivery date'|pgettext('RegisterEntry')"
    :labelAlign="labelAlign"
    :helpTooltip="'Receive or delivery date.'|pgettext('RegisterEntry|Help|Delivery date')"
  >
    <ItpFormDatetime
      name="delivery_date"
      v-model="item.delivery_date"
      :readonly="item.isReadonly"
    >
    </ItpFormDatetime>
  </ItpFormGroup>
  <ItpFormGroup
    labelColsMd="3"
    contentColsMd="5"
    name="delivery_date"
    :label="'Delivery modes'|pgettext('RegisterEntry')"
    :labelAlign="labelAlign"
  >
    <ItpFormSelect2
      name="delivery_modes"
      v-model="item.delivery_modes"
      :options="deliveryModes"
      valueField="name"
      textField="name"
      multiple
    >
    </ItpFormSelect2>
  </ItpFormGroup>
  <ItpFormGroup
    labelColsMd="3"
    contentColsMd="3"
    name="due_date"
    :label="'Due date'|pgettext('RegisterEntry')"
    :labelAlign="labelAlign"
  >
    <ItpFormDatetime
      name="due_date"
      v-model="item.due_date"
      :readonly="item.isReadonly"
    >
    </ItpFormDatetime>
  </ItpFormGroup>
  <ItpFormGroup
    labelColsMd="3"
    contentColsMd="3"
    name="priority"
    :label="'Priority'|pgettext('RegisterEntry')"
    :labelAlign="labelAlign"
  >
    <ItpFormSelect
      name="priority"
      v-model="item.priority"
      :options="priorities"
      :readonly="item.isReadonly"
    >
    </ItpFormSelect>
  </ItpFormGroup>
  <ItpFormGroup
    labelColsMd="3"
    contentColsMd="5"
    name="storage_location"
    :label="'Storage location'|pgettext('RegisterEntry')"
    :labelAlign="labelAlign"
    :helpTooltip="'The description or number of the document\'s storage location.'|pgettext('RegisterEntry|Help|Storage location')"
  >
    <ItpFormInput
      name="storage_location"
      v-model="item.storage_location"
      :readonly="item.isReadonly"
    >
    </ItpFormInput>
  </ItpFormGroup>
  <hr>
  </hr>
  <ItpFormGroup
    labelColsMd="3"
    contentColsMd="8"
    name="notes"
    :label="'Notes'|pgettext('RegisterEntry')"
    :labelAlign="labelAlign"
  >
    <ItpFormTextarea
      name="notes"
      v-model="item.notes"
      :readonly="item.isReadonly"
    >
    </ItpFormTextarea>
  </ItpFormGroup>
  <hr
    v-if="item.id"
  >
  </hr>
  <UcAttachmentsList
    :parent="item"
    v-if="item.id"
  >
  </UcAttachmentsList>
</ItpUsercontrol>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class FieldsetRegisterEntry extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "usercontrol",
  };

  beforeCreate() {
  }

  onReferenceEntrySelected(...args: any[]) {
    const [option] = args;

    if (this.item.id == null && option.invoice_type === 'proforma') {
      this.item.invoice.amount = option.amount;
      this.item.invoice.fulfillment_date = option.fulfillment_date;
      this.item.invoice.due_date = option.due_date;
      this.item.partner_id = option.client_id;
    }
  }

  onReferenceNumberChanged(...args: any[]) {
    const [referenceNumber] = args;

    if (!referenceNumber || !referenceNumber.trim().length) {
      return;
    }

    const item = this.item;

    if (item.document_type == 'invoice' && item.isNew && (!item.invoice || !item.invoice.id)) {
      this.checkInvoiceExists(referenceNumber.trim());
    }
  }

  checkInvoiceExists(...args: any[]) {
    const [invoiceNumber] = args;
    this.$fn
      .fetch('check', {
        parameters: {
          kind: 'invoice',
          op: 'exists',
          query: invoiceNumber,
          company_id: this.item.version.company_id,
          partner_id: _.get(this.item.partner, 'id'),
        }
      })
      .then(resp => {
        if (resp.passed) {
          this.invoiceCheckResult = resp.data;
          return;
        }

        this.invoiceCheckResult = null;
      });
  }

  assignInvoiceCheckResult(...args: any[]) {
    if (!this.invoiceCheckResult) {
      return
    }

    const item = this.item

    item.invoice = this.invoiceCheckResult

    if (!item.partner || !item.partner.id) {
      item.partner = this.invoiceCheckResult.partner || this.invoiceCheckResult.client;
    }

    this.invoiceCheckResult = null
  }

  @Prop({
    required: true,
    type: Object,
  })
  item!: object;

  @Watch('item')
  onItem(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("item")
  }

  @Prop({
    type: String,
    default: "right",
  })
  labelAlign!: string;

  @Watch('labelAlign')
  onLabel_align(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("labelAlign")
  }

  @Prop({
    type: Object,
  })
  form!: object;

  @Watch('form')
  onForm(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("form")
  }

  @Prop({
    type: Boolean,
  })
  isSaving!: boolean;

  @Watch('isSaving')
  onIs_saving(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("isSaving")
  }

  priorities!: any;
  documentTypes!: any;

  async $$load_documentTypes() {
    return this.$fn.getEnumValuesFromSchema('RegisterDocumentType')
  }

  directions!: any;

  async $$load_directions() {
    return this.$fn.getEnumValuesFromSchema('RegisterEntryDirection')
  }

  invoiceTypes!: any;

  async $$load_invoiceTypes() {
    return this.$fn.getEnumValuesFromSchema('InvoiceType')
  }

  paymentMethods!: any;

  async $$load_paymentMethods() {
    return this.$fn.fetch('list_payment_method')
      .then(data => _.map(data, p => ({
        value: p.id,
        text: this.$fn.pgettext('PaymentMethod', p.name)
      })))
  }

  tags!: any;

  async $$load_tags() {
    return this.$fn.fetch('get_tags', { parameters: { tag_type: 'register-entry:*' } })
  }

  categories!: any;

  async $$load_categories() {
    return _.get(this.$data.tags, 'register-entry:category', [])
  }

  statuses!: any;

  async $$load_statuses() {
    return _.get(this.$data.tags, 'register-entry:status', [])
  }

  clerks!: any;

  async $$load_clerks() {
    return _.get(this.$data.tags, 'register-entry:clerk', [])
  }

  deliveryModes!: any;

  async $$load_deliveryModes() {
    return _.get(this.$data.tags, 'register-entry:delivery-mode', [])
  }

  currencies!: any;
  invoiceCheckResult!: any;
  ux!: any;
  b_8680084583475136_dataSource!: any;

  async $$load_b_8680084583475136_dataSource() {
    return {
      name: "suggest_register_entry",
      parameters: {
        register_id: this.item.version.register_id,
        source: this.item.id,
      }
      ,
    }
  }

  dataMembers = ['priorities', 'documentTypes', 'directions', 'invoiceTypes', 'paymentMethods', 'tags', 'categories', 'statuses', 'clerks', 'deliveryModes', 'currencies', 'invoiceCheckResult', 'ux', 'b_8680084583475136_dataSource'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        priorities: {
          0: this.$fn.pgettext("Priority", "normal"),
          1: this.$fn.pgettext("Priority", "important"),
          2: this.$fn.pgettext("Priority", "urgent"),
        }
        ,
        documentTypes: null,
        directions: null,
        invoiceTypes: null,
        paymentMethods: null,
        tags: null,
        categories: null,
        statuses: null,
        clerks: null,
        deliveryModes: null,
        currencies: ["HUF"
          ,
          "EUR"
          ,
          "USD"
          ,
        ]
        ,
        invoiceCheckResult: null,
        ux: null,
        b_8680084583475136_dataSource: null,
      },
    }
  }

  get invoiceRegister() {
    if (this.loaded) {

      return this.item.document_type === 'invoice'
    }
    return null;
  }

  get contractRegister() {
    if (this.loaded) {

      return this.item.document_type === 'contract'
    }
    return null;
  }

  async evh_7315092382398562_reload(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_reload.executeFromDOM(this, event, scope);
  }

  async act_1468474219929533_emit_7946_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_1468474219929533_emit_7946, alias=undefined
    return {
      event: "documentTypeChanged",
    }
  }

  async evh_1468474219929533_input(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1468474219929533_input.executeFromDOM(this, event, scope);
  }

  async act_6917646200545441_script_7948_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_6917646200545441_script_7948, alias=undefined
    this.onReferenceNumberChanged($event.originalEvent)
  }

  async act_6917646200545441_script_7948_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_6917646200545441_script_7948, alias=undefined
    return {
      value: () => this.act_6917646200545441_script_7948_getActionArgs_value($event),
    }
  }

  async evh_6917646200545441_input(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_6917646200545441_input.executeFromDOM(this, event, scope);
  }

  async act_6941071772471093_script_7950_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_6941071772471093_script_7950, alias=undefined
    this.assignInvoiceCheckResult()
  }

  async act_6941071772471093_script_7950_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_6941071772471093_script_7950, alias=undefined
    return {
      value: () => this.act_6941071772471093_script_7950_getActionArgs_value($event),
    }
  }

  async evh_6941071772471093_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_6941071772471093_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async act_7463771596263925_emit_7952_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_7463771596263925_emit_7952, alias=undefined
    return {
      event: "close",
    }
  }

  async act_7463771596263925_showModal_7954_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_7463771596263925_showModal_7954, alias=undefined
    return {
      name: "CreateInvoice",
      props: {
        registerEntry: this.item.id,
      }
      ,
    }
  }

  async evh_7463771596263925_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7463771596263925_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async act_8680084583475136_script_7956_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_8680084583475136_script_7956, alias=undefined
    this.onReferenceEntrySelected($event.data.option)
  }

  async act_8680084583475136_script_7956_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_8680084583475136_script_7956, alias=undefined
    return {
      value: () => this.act_8680084583475136_script_7956_getActionArgs_value($event),
    }
  }

  async evh_8680084583475136_optionSelected(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_8680084583475136_optionSelected.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_reloadComponentData_7944: actions.ReloadComponentDataAction;
    evh_7315092382398562_reload_7943: actions.EventHandlerImpl;
    evh_7315092382398562_reload: actions.EventHandlerGroup;
    act_1468474219929533_emit_7946: actions.EmitAction;
    evh_1468474219929533_input_7945: actions.EventHandlerImpl;
    evh_1468474219929533_input: actions.EventHandlerGroup;
    act_6917646200545441_script_7948: actions.ScriptAction;
    evh_6917646200545441_input_7947: actions.EventHandlerImpl;
    evh_6917646200545441_input: actions.EventHandlerGroup;
    act_6941071772471093_script_7950: actions.ScriptAction;
    evh_6941071772471093_clickPreventStop_7949: actions.EventHandlerImpl;
    evh_6941071772471093_clickPreventStop: actions.EventHandlerGroup;
    act_7463771596263925_emit_7952: actions.EmitAction;
    evh_7463771596263925_clickPreventStop_7951: actions.EventHandlerImpl;
    act_7463771596263925_showModal_7954: actions.ShowModalAction;
    evh_7463771596263925_clickPreventStop_7953: actions.EventHandlerImpl;
    evh_7463771596263925_clickPreventStop: actions.EventHandlerGroup;
    act_8680084583475136_script_7956: actions.ScriptAction;
    evh_8680084583475136_optionSelected_7955: actions.EventHandlerImpl;
    evh_8680084583475136_optionSelected: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_reloadComponentData_7944 = new actions.ReloadComponentDataAction(
      {
        events: [],
      }
    );
    const evh_7315092382398562_reload_7943 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_reloadComponentData_7944,
        event: "reload",
        displayName: "reloadComponentData",
      }
    );
    const evh_7315092382398562_reload = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_reload_7943],
      }
    );
    const act_1468474219929533_emit_7946 = new actions.EmitAction(
      {
        actionArgs: this.act_1468474219929533_emit_7946_getActionArgs,
        events: [],
      }
    );
    const evh_1468474219929533_input_7945 = new actions.EventHandlerImpl(
      {
        action: act_1468474219929533_emit_7946,
        event: "input",
        displayName: "emit",
      }
    );
    const evh_1468474219929533_input = new actions.EventHandlerGroup(
      {
        handlers: [evh_1468474219929533_input_7945],
      }
    );
    const act_6917646200545441_script_7948 = new actions.ScriptAction(
      {
        actionArgs: this.act_6917646200545441_script_7948_getActionArgs,
        events: [],
      }
    );
    const evh_6917646200545441_input_7947 = new actions.EventHandlerImpl(
      {
        action: act_6917646200545441_script_7948,
        event: "input",
        displayName: "script",
      }
    );
    const evh_6917646200545441_input = new actions.EventHandlerGroup(
      {
        handlers: [evh_6917646200545441_input_7947],
      }
    );
    const act_6941071772471093_script_7950 = new actions.ScriptAction(
      {
        actionArgs: this.act_6941071772471093_script_7950_getActionArgs,
        events: [],
      }
    );
    const evh_6941071772471093_clickPreventStop_7949 = new actions.EventHandlerImpl(
      {
        action: act_6941071772471093_script_7950,
        event: "click.prevent.stop",
        displayName: "script",
      }
    );
    const evh_6941071772471093_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_6941071772471093_clickPreventStop_7949],
      }
    );
    const act_7463771596263925_emit_7952 = new actions.EmitAction(
      {
        actionArgs: this.act_7463771596263925_emit_7952_getActionArgs,
        events: [],
      }
    );
    const evh_7463771596263925_clickPreventStop_7951 = new actions.EventHandlerImpl(
      {
        action: act_7463771596263925_emit_7952,
        event: "click.prevent.stop",
        displayName: "emit",
      }
    );
    const act_7463771596263925_showModal_7954 = new actions.ShowModalAction(
      {
        actionArgs: this.act_7463771596263925_showModal_7954_getActionArgs,
        events: [],
      }
    );
    const evh_7463771596263925_clickPreventStop_7953 = new actions.EventHandlerImpl(
      {
        action: act_7463771596263925_showModal_7954,
        event: "click.prevent.stop",
        displayName: "showModal",
      }
    );
    const evh_7463771596263925_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_7463771596263925_clickPreventStop_7951, evh_7463771596263925_clickPreventStop_7953],
      }
    );
    const act_8680084583475136_script_7956 = new actions.ScriptAction(
      {
        actionArgs: this.act_8680084583475136_script_7956_getActionArgs,
        events: [],
      }
    );
    const evh_8680084583475136_optionSelected_7955 = new actions.EventHandlerImpl(
      {
        action: act_8680084583475136_script_7956,
        event: "optionSelected",
        displayName: "script",
      }
    );
    const evh_8680084583475136_optionSelected = new actions.EventHandlerGroup(
      {
        handlers: [evh_8680084583475136_optionSelected_7955],
      }
    );
    return {
      act_7315092382398562_reloadComponentData_7944,
      evh_7315092382398562_reload_7943,
      evh_7315092382398562_reload,
      act_1468474219929533_emit_7946,
      evh_1468474219929533_input_7945,
      evh_1468474219929533_input,
      act_6917646200545441_script_7948,
      evh_6917646200545441_input_7947,
      evh_6917646200545441_input,
      act_6941071772471093_script_7950,
      evh_6941071772471093_clickPreventStop_7949,
      evh_6941071772471093_clickPreventStop,
      act_7463771596263925_emit_7952,
      evh_7463771596263925_clickPreventStop_7951,
      act_7463771596263925_showModal_7954,
      evh_7463771596263925_clickPreventStop_7953,
      evh_7463771596263925_clickPreventStop,
      act_8680084583475136_script_7956,
      evh_8680084583475136_optionSelected_7955,
      evh_8680084583475136_optionSelected,
    }
  }
}

Vue.component("FieldsetRegisterEntry", FieldsetRegisterEntry);

</script>